document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init () {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images () {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg () {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup ($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup (e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init () {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick () {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback () {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView () {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes () {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints (str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper () {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
          prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

 class YGSwiperVideo extends HTMLElement {
  constructor() {
    super()
    this.swiper = null;
    this.videos = [];
    this.currentVideoIndex = 0; // 当前正在播放的视频全局索引（0-4）
    this.playTimer = null; // 播放定时器
    this.isManualSlide = false; // 标记是否是手动切换slide
    this.PLAY_DURATION = 3000; // 每个视频播放3秒
  }

  connectedCallback () {
    this.getAllAttributes()
    this.initSwiper()
  }

  get getCurrentSlidesPerView () {
    if (!this['breakpoints']) return 1;
    const screenWidth = window.innerWidth;
    const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);
    let current = sortedKeys[0];
    for (let i = 0; i < sortedKeys.length; i++) {
      if (screenWidth >= sortedKeys[i]) {
        current = sortedKeys[i];
      } else {
        break;
      }
    }
    return this['breakpoints'][current].slidesPerView;
  }

  getAllAttributes () {
    let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
    let jsonAttrs = ['breakpoints']
    for (const attr of this.attributes) {
      if (attr.name.startsWith('data-')) {
        const cleanName = attr.name.slice(5);
        let value = attr.value;
        if (booleanAttrs.includes(cleanName)) {
          value = value === 'true';
        } else if (jsonAttrs.includes(cleanName)) {
          value = this.parseSwiperBreakpoints(value);
        }
        this[cleanName] = value;
      }
    }
  }

  parseSwiperBreakpoints (str) {
    const result = {};
    const pairs = str.split(',');
    for (const pair of pairs) {
      const [breakpoint, values] = pair.split(':');
      if (!breakpoint || !values) continue;
      const [slides, space] = values.split('-').map(Number);
      result[breakpoint.trim()] = {
        slidesPerView: slides,
        spaceBetween: space
      };
    }
    return result;
  }

  /**
   * 初始化所有视频元素
   */
  initVideos() {
    const slides = this.querySelectorAll('.swiper-slide');
    this.videos = [];
    
    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (video) {
        video.autoplay = false;
        video.muted = true;
        this.videos[index] = video;
      }
    });
  }

  /**
   * 暂停所有视频并重置到开始位置
   */
  pauseAllVideos() {
    this.videos.forEach(video => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  /**
   * 播放指定索引的视频
   */
  playVideoAtIndex(index) {
    if (index < 0 || index >= this.videos.length) return;
    
    // 先暂停所有视频
    this.pauseAllVideos();
    
    // 播放指定索引的视频
    const video = this.videos[index];
    if (video) {
      if (video.readyState >= 2) {
        video.currentTime = 0;
        video.play().catch(err => {
          console.warn('视频播放失败:', err);
        });
      } else {
        const playWhenReady = () => {
          video.currentTime = 0;
          video.play().catch(err => {
            console.warn('视频播放失败:', err);
          });
          video.removeEventListener('loadeddata', playWhenReady);
        };
        video.addEventListener('loadeddata', playWhenReady);
        video.load();
      }
    }
  }

  /**
   * 获取当前可视区域的第一个slide索引
   */
  getFirstVisibleSlideIndex() {
    if (!this.swiper) return 0;
    return this.swiper.activeIndex;
  }

  /**
   * 获取当前可视区域显示的slide数量
   */
  getVisibleSlidesCount() {
    return this.getCurrentSlidesPerView;
  }

  /**
   * 开始自动播放逻辑
   */
  startAutoPlay() {
    // 清除之前的定时器
    if (this.playTimer) {
      clearTimeout(this.playTimer);
      this.playTimer = null;
    }

    // 如果当前视频索引超出范围，重置为0
    if (this.currentVideoIndex >= this.videos.length) {
      this.currentVideoIndex = 0;
    }

    // 播放当前索引的视频
    this.playVideoAtIndex(this.currentVideoIndex);

    // 3秒后切换到下一个视频
    this.playTimer = setTimeout(() => {
      this.currentVideoIndex++;
      
      // 检查是否需要切换swiper
      const slidesPerView = this.getVisibleSlidesCount();
      const currentSlideIndex = this.getFirstVisibleSlideIndex();
      
      // 如果当前视频索引超出了可视区域，需要切换swiper
      if (this.currentVideoIndex >= currentSlideIndex + slidesPerView) {
        // 检查是否还有更多slides
        if (this.currentVideoIndex < this.videos.length) {
          // 左移一项（显示后面的内容）
          this.isManualSlide = true; // 标记为手动切换，避免触发slideChange逻辑
          this.swiper.slideTo(this.currentVideoIndex);
          // slideChange事件会触发，但isManualSlide为true，会执行handleManualSlideChange
        } else {
          // 已经到最后一个，右移回到第一个
          this.currentVideoIndex = 0;
          this.isManualSlide = true;
          this.swiper.slideTo(0);
        }
      } else {
        // 不需要切换swiper，继续播放下一个视频
        this.startAutoPlay();
      }
    }, this.PLAY_DURATION);
  }

  /**
   * 处理手动切换slide（用户点击左右按钮或滑动）
   */
  handleManualSlideChange() {
    // 清除自动播放定时器
    if (this.playTimer) {
      clearTimeout(this.playTimer);
      this.playTimer = null;
    }

    // 暂停所有视频并复原
    this.pauseAllVideos();

    // 获取可视区域的第一个slide索引
    const firstVisibleIndex = this.getFirstVisibleSlideIndex();
    
    // 设置当前视频索引为可视区域的第一个
    this.currentVideoIndex = firstVisibleIndex;

    // 播放可视区域的第一个视频
    this.playVideoAtIndex(this.currentVideoIndex);

    // 3秒后继续自动播放逻辑
    this.playTimer = setTimeout(() => {
      this.currentVideoIndex++;
      this.startAutoPlay();
    }, this.PLAY_DURATION);
  }

  /**
   * 处理 slide 切换事件
   */
  handleSlideChange() {
    if (!this.swiper) return;
    
    if (this.isManualSlide) {
      // 如果是程序触发的切换（自动播放导致的切换）
      this.isManualSlide = false;
      // 继续自动播放逻辑
      this.startAutoPlay();
    } else {
      // 如果是用户手动切换（点击按钮或滑动）
      this.handleManualSlideChange();
    }
  }

  initSwiper () {
    const swiper = new Swiper(this, {
      initialSlide: 0,
      slidesPerView: 4,
      effect: this['effect'],
      loop: this['loop'],
      centeredSlides: this['centered-slides'],
      // 不启用自动轮播
      autoplay: false,
      pagination: this['pagination'] ? {
        el: '.swiper-pagination',
        clickable: true,
      } : false,
      navigation: this['navigation'] ? {
        nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
        prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
      } : false,
      scrollbar: this['scrollbar'] ? {
        el: ".swiper-scrollbar",
        hide: true,
      } : false,
      breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
      on: {
        init: e => {
          this.swiper = e;
          if (e.passedParams.loop) {
            let num = this.getCurrentSlidesPerView;
            let sliderLength = e.slides.length;
            if (this['centered-slides']) {
              num += 2;
            }
            if (sliderLength <= num) {
              for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                e.slides.forEach((slide) => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                })
              }
              setTimeout(() => {
                let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                $bullets.forEach((bullet, index) => {
                  if (index >= sliderLength) {
                    bullet.style.display = 'none';
                  }
                })
              }, 250)
            }
          }

          // 初始化视频
          setTimeout(() => {
            this.initVideos();
            // 重置当前视频索引为0
            this.currentVideoIndex = 0;
            // 开始自动播放第一个视频
            this.startAutoPlay();
          }, 100);
        },

        slideChange: () => {
          this.handleSlideChange();
        },

        slideChangeTransitionStart: () => {
          // 在过渡开始时暂停所有视频
          this.pauseAllVideos();
        },

        slideChangeTransitionEnd: () => {
          // 过渡结束后，如果不是手动切换，继续播放逻辑
          // 如果是手动切换，handleSlideChange已经处理了
        }
      }
    })
  }
}

if (!window.customElements.get('yg-swiper-video')) {
  window.customElements.define('yg-swiper-video', YGSwiperVideo)
}

  class YGRichtext extends HTMLElement {
    constructor() {
      super()
      this.$btnList = this.btnList
      this.$itemList = this.itemList
      this.$headerList = this.headerList
    }
    get btnList () {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-richtext__icon')
      }
      return this.$btnList
    }
    get itemList () {
      if (!this.$itemList) {
        this.$itemList = this.querySelectorAll('.yg-richtext__content')
      }
      return this.$itemList
    }
    get headerList () {
      if (!this.$headerList) {
        this.$headerList = this.querySelectorAll('.yg-richtext__header')
      }
      return this.$headerList
    }

    handClick (e, i) {
      if (this.$itemList[i].classList.contains('active')) {
        this.$itemList[i].classList.remove('active')
        this.$btnList[i].classList.remove('active')
        this.$itemList[i].style.maxHeight = 0 + 'px'
      } else {
        const height = this.$itemList[i].scrollHeight
        this.$itemList[i].classList.add('active')
        this.$itemList[i].style.maxHeight = height + 'px'
        this.$btnList[i].classList.add('active')
      }
    }
    connectedCallback () {
      this.$headerList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
    }

  }
  if (!window.customElements.get('yg-richtext')) {
    window.customElements.define('yg-richtext', YGRichtext)
  }


  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init () {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick () {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('shopify-buy-it-now-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }
})